export default "__VITE_ASSET__4cb6739c__"